import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: '600px',
      maxWidth: '800px',
      backgroundColor: '#1a1a1a',
      color: 'white',
    },
  },
  dialogTitle: {
    backgroundColor: '#2a2a2a',
    borderBottom: '1px solid #444',
    '& h2': {
      color: 'white',
      fontSize: '18px',
      fontWeight: 'bold',
    },
  },
  searchContainer: {
    display: 'flex',
    gap: '12px',
    marginBottom: '20px',
    alignItems: 'center',
  },
  searchInput: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      color: 'white',
      '& fieldset': {
        borderColor: '#666',
      },
      '&:hover fieldset': {
        borderColor: '#888',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#2196F3',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#aaa',
    },
  },
  searchButton: {
    backgroundColor: '#2196F3',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1976D2',
    },
  },
  addButton: {
    backgroundColor: '#4CAF50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
  searchResults: {
    backgroundColor: '#2a2a2a',
    padding: '16px',
    borderRadius: '4px',
    marginBottom: '20px',
  },
  tableContainer: {
    backgroundColor: '#2a2a2a',
    '& .MuiTableCell-head': {
      color: '#aaa',
      fontWeight: 'bold',
      borderBottom: '1px solid #444',
    },
    '& .MuiTableCell-body': {
      color: 'white',
      borderBottom: '1px solid #333',
    },
  },
  roleBadge: {
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  hostBadge: {
    backgroundColor: '#2196F3',
    color: 'white',
  },
  coHostBadge: {
    backgroundColor: '#4CAF50',
    color: 'white',
  },
  removeButton: {
    color: '#ff6b6b',
    '&:hover': {
      backgroundColor: 'rgba(255, 107, 107, 0.1)',
    },
  },
  select: {
    color: 'white',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#666',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#888',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2196F3',
    },
    '& .MuiSelect-icon': {
      color: 'white',
    },
  },
  menuItem: {
    '&.Mui-selected': {
      backgroundColor: '#2196F3',
    },
  },
}));